"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _home_ASM_RSM = _interopRequireDefault(require("./home_ASM_RSM.vue"));
var _home = _interopRequireDefault(require("./home.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    HomeAsmRsm: _home_ASM_RSM.default,
    Home: _home.default
  },
  data: function data() {
    return {
      homeType: '',
      role: '',
      isMenuVisible: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['functions'])),
  watch: {
    $route: {
      handler: function handler(val, oldVal) {
        // 在首页切换角色后会在路由后面带上参数用于判断，在这里隐藏路由后的参数
        var newUrl = window.location.href.split('?')[0];
        history.replaceState(null, null, newUrl);
        // 更新首页
        this.initHome();
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted: function mounted() {
    // 动态显示首页内容
    this.initHome();
    this.role = this.$store.getters.roles[0];
  },
  methods: {
    initHome: function initHome() {
      // 首页类型
      var homeType = '';
      // 获取functions列表
      var functionsList = this.$store.state.permission.functions || {};
      // 只要存在首页的key，就显示哪个首页
      if (functionsList.hasOwnProperty('salesLeader_home')) {
        homeType = 'salesLeader_home';
      } else if (functionsList.hasOwnProperty('asm_rsm_home')) {
        homeType = 'asm_rsm_home';
      } else {
        homeType = 'normal';
      }
      this.homeType = homeType;
      this.$store.dispatch('permission/setHomeType', homeType);
    },
    goChatbot: function goChatbot() {
      var chatbotFunctions = this.functions['chatbot'];
      if (chatbotFunctions.length === 1 && chatbotFunctions[0] === 'CHATBOT_KNOWLEDGE') {
        this.$router.push({
          path: '/chatbotModule/chatbot',
          query: {
            knowledgeType: '1'
          }
        });
      } else if (chatbotFunctions.length === 1 && chatbotFunctions[0] === 'CHATBOT_ANALYSIS') {
        this.$router.push({
          path: '/chatbotModule/chatbot',
          query: {
            knowledgeType: '2'
          }
        });
      } else if (chatbotFunctions.length === 2 && chatbotFunctions.includes('CHATBOT_KNOWLEDGE') && chatbotFunctions.includes('CHATBOT_ANALYSIS')) {
        this.toggleMenu();
      }
    },
    toggleMenu: function toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    isNewCh: function isNewCh() {
      //  && this.role != 'CP Sales leader' && this.role != 'CP-SR'
      if (this.role.startsWith('CP') || this.role.startsWith('4S') || this.role.startsWith('EC') || this.role.startsWith('PL')) {
        return true;
      }
      return false;
    }
  }
};